import { SUBSCRIPTION_STATUS } from './const';

const STATUS_LABEL = {
  [SUBSCRIPTION_STATUS.active]: 'Active',
  [SUBSCRIPTION_STATUS.pastDue]: 'payment failed',
  [SUBSCRIPTION_STATUS.canceled]: 'cancelled',
};

export const getSubscriptionStatusLabel = (status) => STATUS_LABEL[status] || status;
